<script setup lang="ts">
import { Download } from 'lucide-vue-next'
import { useFlowEditorContext } from '../../composables/useFlowEditor'

/** Canvas zoom info, view reset and export/debug actions. */
const editor = useFlowEditorContext()
const { viewport, resetView } = editor.viewport
const { nodes } = editor.document
const { downloadCanvasSvg, copyFlowJson } = editor
</script>

<template>
  <div class="flow-settings__panel">
    <div class="flow-settings__meta">
      {{ $t('flow.currentScale') }}: {{ viewport.scale.toFixed(2) }}x
    </div>
    <div class="flow-settings__meta">{{ $t('flow.infiniteWorld') }}</div>

    <h3 class="flow-subtitle">{{ $t('flow.canvasView') }}</h3>
    <button type="button" class="pl-btn pl-btn--secondary" @click="resetView">
      {{ $t('flow.resetView') }}
    </button>

    <h3 class="flow-subtitle">{{ $t('flow.canvasExport') }}</h3>
    <button
      type="button"
      class="pl-btn pl-btn--secondary export-btn"
      :disabled="nodes.length === 0"
      :title="$t('flow.downloadSvgTitle')"
      @click="downloadCanvasSvg"
    >
      <Download style="width: 0.9rem; height: 0.9rem" aria-hidden="true" />
      {{ $t('flow.downloadAsSvg') }}
    </button>

    <h3 class="flow-subtitle">{{ $t('flow.canvasDebug') }}</h3>
    <button type="button" class="pl-btn pl-btn--secondary" @click="copyFlowJson">
      {{ $t('flow.copyFlowJson') }}
    </button>
  </div>
</template>

<style scoped src="../styles/inspectorForm.css"></style>
